/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
export default {
    name: 'hsal',
    data() {
        return {
            crumbsList:Object.freeze([{
                name:'审判研究',
                key:'hsal'
            }]),
            zdxalData: {
                image: '/static/image/ejym/hsal/img-zdxan.png',
                data: []
            },
            ndaljxData: {
                image: '/static/image/ejym/hsal/img-ndan.png',
                data: []
            },
            gbalData: {
                image: '/static/image/ejym/hsal/img-gb.png',
                data: []
            },
            dffyjxalData: {
                image: '/static/image/ejym/hsal/img-dffyjxal.png',
                data: []
            },
            rmfyalData: {
                image: '/static/image/ejym/hsal/img-rmfyal.png',
                data: []
            },
            dywzData:{
                image: '/static/image/ejym/lltt/img-dywz.png',
                data: []
            },
            ztzlList: [],
            activeFirst: 0,
            tabList:[
                {
                    name: '指导性案例',
                    code: 'zdxalData'
                },
                {
                    name: '公报案例',
                    code: 'gbalData'
                },
                {
                    name: '典型案例',
                    code: 'ndaljxData'
                },
                {
                    name: '地方法院精选案例',
                    code: 'dffyjxalData'
                },
                {
                    name: '人民法院案例库',
                    code: 'rmfyalData'
                }


            ],
            activeTab:'zdxalData'
        };
    },
    created() {
        this.init();
    },
    computed: {
        marginLeft() {
            return `-${this.activeFirst * 284}px`;
        }
    },
    methods: {
        init() {
            this.initData();
            this.initZtzl();
        },
        initZtzl() {
            const url = window.fdConfig.url.zt.index;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        this.ztzlList = res.data;
                    }
                });
        },
        // 跳转到其他页面
        goToPage(path, query) {
            this.$router.push({path: path, query: query});
        },
        clickLeft() {
            if (this.activeFirst > 3) {
                this.activeFirst -= 4;
            } else {
                this.activeFirst = 0;
            }
        },
        clickRight() {
            if (this.activeFirst < this.ztzlList.length - 4) {
                this.activeFirst += 4;
            }
        },
        initData() {
            console.log(window.fdConfig.url.Hsal.hsalindex);
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,

                url: window.fdConfig.url.Hsal.hsalindex.replace('{id}', '0')
            }).then((res) => {
                this.zdxalData.data = res.data.zdxal;
                this.ndaljxData.data = res.data.ndaljx;
                this.gbalData.data = res.data.gbal;
                this.dffyjxalData.data = res.data.dffyjxal;
                this.dywzData.data = res.data.dywz;
                this.rmfyalData.data = res.data.rmfyal;
            });
        },
        // 截取信息加'...'
        getMsg(msg) {
            const strLength = 145;
            return msg.length > strLength ? `${msg.substring(0, strLength)}...` : msg;
        },
        openUrl(url) {
            window.open(url, '_blank');
        },
        // 查看更多
        handleMore(type) {
            this.$router.push({
                path: '/hsal/more',
                query: {tab: type}
            });
        },
        // 查看详情
        handleDetail(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active:'hsal', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
        },
        clickAlxq(type) {
            this.$router.push({
                path: '/hsal/xq',
                query: {tab: type}
            });
        }
    }
};

